var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM4 20C4 28.8366 11.1634 36 20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20Z",
    fill: "#EFF0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 23.1562 39.253 26.2676 37.8201 29.0798C36.3872 31.892 34.3091 34.3252 31.7557 36.1803C29.2023 38.0355 26.246 39.26 23.1287 39.7538C20.0113 40.2475 16.8214 39.9965 13.8197 39.0211L15.0557 35.2169C17.4571 35.9972 20.0091 36.198 22.503 35.803C24.9968 35.408 27.3618 34.4284 29.4046 32.9443C31.4473 31.4601 33.1098 29.5136 34.2561 27.2638C35.4024 25.0141 36 22.525 36 20H40Z",
    fill: "#3DD598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.7017aaba.svg";
export { ForwardRef as ReactComponent };